module.exports = "<select-organs-custom-multi-select\n  #selectOrgansMultiRef\n  (select-menu-event)=\"onOrgansSelected($event)\"\n  [appearance]=\"appearance\"\n  [length]=\"length\"\n    [menuOptions]=\"organMenuOptions\">\n</select-organs-custom-multi-select>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/select-organs/select-organs.component.html
// module id = ./src/app/common/select-organs/select-organs.component.html
// module chunks = main